import css from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

const asset = '/media/community/pc/';
const { EFPic } = createEFPic(asset);

export default function Regional() {
    const { t } = useLang('communitylang.joinUsNow');
    const { Link } = useGlobal();

    const cardsData = [
        {
            key: 1,
            title: t('card_1_title'),
            desc: t('card_1_desc'),
            img: ['area_1.png', 'area_1.png'],
            url: 'https://bit.ly/3Mxta6S',
        },
        {
            key: 2,
            title: t('card_2_title'),
            desc: t('card_2_desc'),
            img: ['area_2.png', 'area_2.png'],
            url: 'https://bit.ly/3IAwHAp',
        },
        {
            key: 3,
            title: t('card_3_title'),
            desc: t('card_3_desc'),
            img: ['area_3.png', 'area_3.png'],
            url: 'https://bit.ly/3Wr4G3M',
        },
        {
            key: 4,
            title: t('card_4_title'),
            desc: t('card_4_desc'),
            img: ['area_4.png', 'area_4.png'],
            url: 'https://bit.ly/3WAr7DJ',
        },
        {
            key: 5,
            title: t('card_5_title'),
            desc: t('card_5_desc'),
            img: ['area_5.png', 'area_5.png'],
            url: 'https://bit.ly/421ttMX',
        },
        {
            key: 6,
            title: t('card_6_title'),
            desc: t('card_6_desc'),
            img: ['area_6.png', 'area_6.png'],
            url: 'https://bit.ly/3IvGjMr',
        },
        {
            key: 7,
            title: t('card_7_title'),
            desc: t('card_7_desc'),
            img: ['area_7.png', 'area_7.png'],
            url: 'https://bit.ly/3DU5upg',
        },
    ];

    return (
        <div className={`regional ${css.regional}`}>
            <div className="regional-content">
                <p className="regional-title">{t('title')}</p>
                <p className="regional-desc">{t('desc')}</p>
            </div>
            <div className="regional-cards">
                {cardsData.map((card) => (
                    <Link
                        key={card.key}
                        href={card.url}
                        ariaLabel={t('join')}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'community_button',
                            list_name: t('gap_title'),
                            button_name: t('join'),
                        }}
                    >
                        <div className="card-item">
                            <EFPic className="area-img" name={card.img} />
                            <p className="item-title">{card?.title}</p>
                            <p className="btn-text">{t('join')}</p>
                        </div>
                    </Link>
                ))}
            </div>
            <p className="bottom-tip">{t('bottom_tip')}</p>
        </div>
    );
}
